import { makeStyles } from 'tss-react/mui';

const name = 'ChainSelectors';

export const useChainSelectorsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  tabs: {
    width: '100%',
  },
  tabsWrapper: {
    width: '100%',
  },
  tabsInner: {
    width: '100%',
  },
  tab: {
    flex: 1,
  },
}));
